export function popupsStoryThirtysix() {

  $(document).on("click", ".js-popup-link-story-thirtysix", function (e) {
    e.preventDefault();
    e.stopPropagation();
    let wrapper = $(".popup-wrapper");
    if ($("#appStoryThirtysix").length > 0) {
      wrapper = $("#appStoryThirtysix .popup-wrapper");
    }
    let id = $(this).attr("data-target");
    wrapper.addClass("active-dark");
    $(id).addClass("active-dark");

    setTimeout(function () {
      $(id).addClass("visible");
    }, 0);

    $("body").one("click.popup", (e) => {
      let $target = $(event.target);
      if(!$target.closest(".popup-window").length && $('.popup-window').is(":visible")){
        closePopup();
      }
    });

    $(document).one("keydown.popupClose", function (e) {
      if (e.keyCode === 27 && wrapper.hasClass("active-dark")) {
        closePopup(e);
      }
    });
  });

  $(document).on("click", ".popup-header button", function (e) {
    closePopup(e)
  });

  function closePopup(e) {
    if (e) {
      e.stopPropagation();
    }
    const wrapper = $(".popup-wrapper");
    const popups = $(".popup-window");

    popups.removeClass("visible");
    setTimeout(() => {
      wrapper.add(popups).removeClass("active-dark");
    }, 250);

    $("body").off("click.popup");
    $(document).off("keydown.popupClose");
  }
}


// WEBPACK FOOTER //
// ./assets/js/modules/popups-story-thirtysix.js